angular.module('bl.basket').directive('blEmptyBasket', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: true,
        controller: emptyBasket
    };
});

function emptyBasket($scope, bbWidgetBasket) {
    $scope.emptyBasket = () => {
        let scope = $scope.$parent.$parent;
        bbWidgetBasket.quickEmptyBasket();
    };
}


// WEBPACK FOOTER //
// ../src/public/javascripts/basket/empty-basket/empty_basket.directive.js